"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_SUCCESS_MESSAGE = exports.SET_INFO_MESSAGE = exports.SET_ERROR_MESSAGE = exports.CLOSE_SNACKBAR = void 0;
exports.CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
exports.SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
exports.SET_INFO_MESSAGE = 'SET_INFO_MESSAGE';
exports.SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
